<template>
  <div class="drawer">
    <el-drawer
      size="900px"
      title="选择宠物笼子位置"
      :visible.sync="drawerStatus"
      @close="close"
      :modal-append-to-body="false"
    >
      <div class="contentCage">
        <div class="con">
          <div class="cageName">宠物负责人</div>
          <div style="height: 10px"></div>
          <div class="cageSaff">
            <div>
              饲养员:<el-select
                style="width: 150px; margin-left: 5px"
                v-model="breederId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in salesList"
                  :key="item._id"
                  :label="item.basic_info.nick_name"
                  :value="item._id"
                >
                </el-option>
              </el-select>
            </div>
           
            <div>
              医生:<el-select
                v-model="doctorId"
                style="width: 150px; margin-left: 5px"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in doctorList"
                  :key="item._id"
                  :label="item.basic_info.nick_name"
                  :value="item._id"
                >
                </el-option>
              </el-select>
            </div>
            <div>
              医助:<el-select
                v-model="doctorAssistantId"
                style="width: 150px"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in assistantList"
                  :key="item._id"
                  :label="item.basic_info.nick_name"
                  :value="item._id"
                >
                </el-option>
              </el-select>
            </div>
            <div>
              美容师:<el-select
                v-model="beauticianId"
                style="width: 150px; margin-left: 5px"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in beauticianList"
                  :key="item._id"
                  :label="item.basic_info.nick_name"
                  :value="item._id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div style="height: 20px"></div>
        </div>
        <div class="con">
          <div class="cageName">笼子分区</div>
          <div style="height: 10px"></div>
          <div class="contentItem">
            <el-radio-group v-model="areaId" @input="handleChangEarea">
              <el-radio label="">全部</el-radio>
              <el-radio label="1">展示区</el-radio>
              <el-radio label="2">洗美区</el-radio>
              <el-radio label="3">寄养区</el-radio>
              <el-radio label="4">住院区</el-radio>
              <el-radio label="5">隔离区</el-radio>
            </el-radio-group>
          </div>
          <div style="height: 20px"></div>
        </div>
        <div
          class="con"
          v-for="(itemb, index) in cageListArr"
          :key="itemb.id"
          v-show="itemb.length"
        >
          <div class="cageName" v-show="itemb.length">
            {{ cagePositionNameList[index] }}
          </div>
          <div class="contentItem">
            <div
              class="cageItem"
              :class="changeClass(item)"
              v-for="item in itemb"
              :key="item.id"
              @click="changeCageId(item)"
            >
              <div>{{ item.cageName }}</div>
              <div
                v-show="item.pets.length"
                v-for="itemA in item.pets.slice(0, 1)"
                :key="itemA.id"
              >
                {{ itemA.petType == "1" ? "猫" : "狗" }}
                {{ item.pets.length }}只
              </div>
              <div v-show="!item.pets.length">{{ item.status.title }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="btnBox">
        <div class="btnItem">取消</div>
        <div class="btnItem submit" @click="sumbit">确定</div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { petReceive } from "@/api/purchaseApi.js";
import { getStaffList } from "@/api/shopStaff.js";
export default {
  props: {
    petId: {
      type: String,
      default: "",
    },
    petCage: {
      type: String,
      default: "",
    },
    receiveShopId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      breederId: "",
      doctorAssistantId: "",
      beauticianId: "",
      doctorId: "",
      salesList: [],
      doctorList: [],
      beauticianList: [], //美容师
      breederList: [], //饲养员
      options: [],
      shopId: this.receiveShopId || this.$store.state.shopId,
      cageId: "",
      drawerStatus: false,
      areaId: "",
      status: "",
      positionId: "",
      areaList: this.$store.state.areaList,
      cageList: [],
      cageListArr: [],
      // 位置列表
      cagePositionList: [],
      cagePositionNameList: [],
      params: {
        pageIndex: 1,
        pageSize: 100,
        keyword: "",
        shopId: this.$store.state.shopId,
        position: "",
        status: 1,
      },
      zhuguanList:[],
      assistantList:[],//医助
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.drawerStatus = true;
      this.getBreederList();
      this.getSalesList();
      this.getCageTree();
      this.getCageList();
      this.get()
    });

    console.log(this.petId);
    console.log("petCage", this.petCage);
  },
  methods: {
    async get() {
      this.params.position = "主管";
      let res = await getStaffList(this.params);
      if (res.code == 0) {
        this.zhuguanList = res.data.data;
        this.getBreederList()
      }
    },
    // 获取饲养员列表
     async getBreederList() {
      this.params.position = "饲养员";
      let res = await getStaffList(this.params);
      if (res.code == 0) {
        this.breederList = res.data.data;
        this.getSalesList();
      }
    },
    // 获取销售列表
    async getSalesList() {
      this.params.position = "销售";
      let res = await getStaffList(this.params);
      if (res.code == 0) {
        this.salesList = res.data.data;
        this.zhuguanList.map((item)=>{
          this.salesList.push(item)
        })
        this.breederList.map((item)=>{
          this.salesList.push(item)
        })
        this.getDoctorList();
      }
    },
 
    // 获取医生列表
     async getDoctorList() {
      this.params.position = "医生";
      let res = await getStaffList(this.params);
      if (res.code == 0) {
        this.doctorList = res.data.data;
        this.getAssistantList()
      }
    },
         // 获取医助列表
    async getAssistantList() {
      this.params.position = "医助";
      let res = await getStaffList(this.params);
      if (res.code == 0) {
        this.assistantList = res.data.data;
        this.getBeauticianList()
      }
    },
    // 获取美容师列表
    async getBeauticianList() {
      this.params.position = "美容师";
      let res = await getStaffList(this.params);
      if (res.code == 0) {
        this.beauticianList = res.data.data;
      }
      console.log(res, "美容师");
    },
    // 确定
    sumbit() {
      if (this.$public.isNull(this.cageId)) {
        this.$message({
          type: "error",
          message: "请选择房间",
        });
        return;
      }

      if (this.petCage == "add") {
        let params = {
          id: [this.petId],
          cageId: this.cageId,
          breederId: this.breederId,
          doctorAssistantId: this.doctorAssistantId,
          beauticianId: this.beauticianId,
          doctorId: this.doctorId,
        };
        let loading = this.$loading();
        console.log(params, "接收提交");
        petReceive(params).then((res) => {
          loading.close();
          if (res.code == 0) {
            this.reset();
            this.$emit("submit");
            this.$message({
              type: "success",
              message: "已接收",
            });
          }
        });
      } else {
        let params = {
          petId: this.petId,
          cageId: this.cageId,
        };
        let loading = this.$loading();
        this.$http
          .post(process.env.VUE_APP_Url_8000 + "/api/pet/join/cage", params)
          .then((res) => {
            loading.close();
            this.$emit("submit");
          });
      }
    },
    reset() {
      this.cageId = "";
      this.breederId = "";
      this.doctorAssistantId = "";
      this.beauticianId = "";
      this.doctorId = "";
    },
    // 选择笼子
    changeCageId(item) {
      if (item.status.value == 2 || item.status.value == 1) {
        this.$message({
          message: "请选择其他房间",
          type: "error",
        });
        return;
      } else if (this.cageId == item.cageId) {
        this.cageId = "";
      } else {
        this.cageId = item.cageId;
      }
    },
    changeClass(item) {
      if (item.status.value == 2 || item.status.value == 1) {
        return "lockClass";
      }
      if (item.cageId == this.cageId) {
        return "pitchClass";
      }
    },

    // 获取笼子位置树
    getCageTree() {
      this.$http
        .get(process.env.VUE_APP_Url_8000 + "/api/cage/area/tree", {
          shopId: this.shopId,
        })
        .then((res) => {
          if (res.code == 0) {
            this.cageData = res.data;
            let arr = [];
            let arrName = [];
            this.cageData.forEach((item) => {
              if (item.children.length) {
                item.children.forEach((itemB) => {
                  arr.push(itemB.id);
                  arrName.push(item.label + "--" + itemB.label);
                });
              }
            });
            this.cagePositionList = arr;
            this.cagePositionNameList = arrName;
          }
        });
    },
    // 获取笼子列表
    getCageList() {
      let params = {
        shopId: this.shopId,
        cageAreaId: this.areaId,
        positionId: this.positionId,
        status: this.status,
      };
      // console.log(params);
      let loading = this.$loading();
      this.$http
        .post(
          process.env.VUE_APP_Url_8000 + "/api/shop/cage/current/status/list",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            // console.log(res.data, "狗笼子列表");
            this.cageList = res.data;
            let allArr = [];
            this.cagePositionList.forEach((itemA) => {
              let arr = this.cageList.filter(
                (itemB) => itemA == itemB.positionId
              );
              allArr.push(arr);
            });
            this.cageListArr = allArr;
          }
        });
    },

    handleChangEarea() {
      this.getCageList();
    },
    // 关闭弹框
    close() {
      this.$emit("submit");
    },
  },
};
</script>

<style scoped lang="scss">
.drawer {
  ::v-deep .el-drawer__body {
    overflow-y: auto;
    padding-bottom: 30px;
  }

  .cageSaff {
    display: flex;
    line-height: 40px;
    & > div {
      display: flex;
      margin: 0 3px;
    }
  }
  .contentCage {
    margin: 0px 20px;
    .con {
      background: #fbfbfb;
      border-radius: 16px;
      padding: 10px 0px;
      margin-bottom: 20px;
      .contentItem {
        margin: 10px 0px;
        margin-left: 10px;
        display: flex;
        flex-wrap: wrap;
        .cageItem {
          margin-bottom: 5px;
          margin-right: 5px;
          text-align: center;
          border-radius: 8px;
          background: #f5f5f6;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          width: 126px;
          height: 80px;
          cursor: pointer;
        }
        .lockClass {
          color: #b0b0bf;
        }
        .pitchClass {
          color: $mainColor;
          border: 1px solid $mainColor;
        }
      }
    }

    .cageName {
      font-weight: 600;
      margin-top: 20px;
      border-left: 3px solid #0272da;
      padding-left: 20px;
      margin-bottom: 20px;
    }
  }
  .btnBox {
    width: 100%;
    font-size: 14px;
    color: #fff;
    line-height: 40px;
    display: flex;
    position: absolute;
    bottom: 0;
    z-index: 10;
    .btnItem {
      text-align: center;
      width: 100%;
      background-color: #d6d6d6;
      cursor: pointer;
      &.submit {
        background-color: $mainColor;
      }
    }
  }
}
</style>